'use client';

import { AD_PLACEMENTS } from './adPlacements';
import { NativeAdSlot } from './NativeAdSlot';

export const PolicyGuideBottomAdSlot = () => (
  <NativeAdSlot {...AD_PLACEMENTS.policyGuideBottom} />
);
